import React from 'react'
import { func, bool, node, array, string } from 'prop-types'
import styled, { css } from 'styled-components'

import { H2, fontSizes } from 'styles/typography'
import { white } from 'styles/colors'

import Wrapper from 'components/Wrapper'
import Section, { SectionBlock } from 'components/Section'
import Question from 'components/vype-plus/Question'
import FaqCategory from 'components/vype-plus/FaqCategory'
import RichText from 'components/RichText'

const Container = styled(Section)`
  background-color: ${props => props.backgroundColor};
`

const Heading = styled(H2)`
  color: ${white};
  text-align: center;
`

const Inner = styled.div`
  margin: 0 auto;
  max-width: 980px;

  ${props =>
    props.full &&
    css`
      max-width: none;
    `}
`

const Disclaimer = styled.p`
  font-size: ${fontSizes.small};
  text-align: center;
  color: ${white};

  a {
    color: ${white};
  }
`

const Faq = ({ faqs, setQuestionExpanded, setCategoryExpanded, backgroundColor, full, disclaimer, title }) => {
  return (
    <Container id="faqs" backgroundColor={backgroundColor}>
      <Wrapper>
        <SectionBlock>
          <Heading>{title || 'Questions? See answers below'}</Heading>
        </SectionBlock>
        <SectionBlock>
          <Inner full={full}>
            {faqs.map((category, i) => (
              <FaqCategory
                handleClick={() => setCategoryExpanded(i, !category.expanded)}
                title={category.title}
                expanded={category.expanded}
                key={i}
              >
                {category.content.map((item, j) => (
                  <Question
                    question={item.question}
                    key={j}
                    expanded={item.expanded}
                    handleClick={() => setQuestionExpanded(i, j, !item.expanded)}
                    id={`question-${i}-${j}`}
                  >
                    <RichText>
                      <p dangerouslySetInnerHTML={{ __html: item.response }} />
                    </RichText>
                  </Question>
                ))}
              </FaqCategory>
            ))}
          </Inner>
        </SectionBlock>
        {disclaimer && (
          <SectionBlock>
            <Disclaimer>{disclaimer}</Disclaimer>
          </SectionBlock>
        )}
      </Wrapper>
    </Container>
  )
}

Faq.propTypes = {
  setQuestionExpanded: func.isRequired,
  setCategoryExpanded: func.isRequired,
  backgroundColor: string,
  title: string,
  faqs: array.isRequired,
  full: bool,
  disclaimer: node
}

export default Faq
